import React, { useContext, useEffect } from 'react';
import { ThemeContext } from '@ifit/themes/ThemeContext';
import Loading from '@ifit/mp-loading';
import { setThemeClass } from '@ifit/themes/setThemeClass';

import GridSection from '../../../components/grid-section';
import InfiniteScroll from '../../../components/infinite-scroll';
import './index.scss';
import favoriteHeart from './img/empty-favorites-placeholder.svg';
import favoriteHeartDark from './img/empty-favorites-placeholder-dark.svg';
import favoriteHeartVault from './img/empty-favorites-placeholder-vault.svg';
import { getSearchState } from '../../search/state/search-state';
import { useFavoritesInfiniteQuery } from '../../../client/query/favorites';
import { setToolbarTitle } from '../../../store/to-native';
import { myFavoritesTitle } from '../../../i18n/translations';

export const Favorites: React.FC = () => {
  const context = useContext(ThemeContext);

  useEffect(() => {
    getSearchState().setViewContext({});
    setToolbarTitle(myFavoritesTitle());
  }, []);

  useEffect(() => {
    setThemeClass(context);
  }, [context]);

  const {
    dataMemo: { hasMoreItems, reset, data: favoriteItems },
    query: { isLoading },
    fetchNextPageCallback,
  } = useFavoritesInfiniteQuery();

  const { theme } = context;
  const favoritesImg = {
    LIGHT: favoriteHeart,
    DARK: favoriteHeartDark,
    VAULT: favoriteHeartVault,
  }[theme];

  if (isLoading) {
    return <Loading absolute data-testid={'loading-spinner'} />;
  }

  return (
    <div className="favorites-view">
      {favoriteItems.length === 0 ? (
        <div className="favorites-empty">
          <img src={favoritesImg} alt="Favorites" />
          <h2>Your favorite workouts will live here</h2>
          <p>
            Go to the Workout&apos;s Details page to start saving your favorite
            workouts
          </p>
        </div>
      ) : (
        <React.Fragment>
          <InfiniteScroll
            reset={reset}
            loadMore={fetchNextPageCallback}
            hasMoreItems={hasMoreItems}
            libraryCards={favoriteItems}
          >
            <GridSection showCategory />
          </InfiniteScroll>
        </React.Fragment>
      )}
    </div>
  );
};

export default Favorites;
